export default function toggleInclusion(arr = [], item, field = undefined) {
  if (field)
    return arr.map((x) => x[field]).includes(item[field])
      ? arr.filter((x) => x[field] !== item[field])
      : [...arr, item];
  else return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
}
